import Alpine from "alpinejs";

// AlpineJS Plugins
import persist from "@alpinejs/persist"; // @see https://alpinejs.dev/plugins/persist
import collapse from "@alpinejs/collapse"; // @see https://alpinejs.dev/plugins/collapse
import intersect from "@alpinejs/intersect"; // @see https://alpinejs.dev/plugins/intersect

// Third Party Libraries

/**
 * Code highlighting library
 * JUST FOR DEMO PURPOSE ONLY FOR HIGHLIGHTING CODE
 * @see https://highlightjs.org/
 */
import hljs from "highlight.js/lib/core";
import xml from "highlight.js/lib/languages/xml";
import json from "highlight.js/lib/languages/json";
import ini from "highlight.js/lib/languages/ini";
import javascript from "highlight.js/lib/languages/javascript";
import yaml from "highlight.js/lib/languages/yaml";
import typescript from "highlight.js/lib/languages/typescript";

/**
 * Carousel Library
 * @see https://swiperjs.com/
 */
import Swiper from "swiper/bundle";

/**
 * Drag & Drop Library
 * @see https://github.com/SortableJS/Sortable
 */
import Sortable from "sortablejs";

/**
 * Drawer Component
 */
import Drawer from "./components/drawer";

//import * as FilePond from "filepond"; // @see https://pqina.nl/filepond/
//import FilePondPluginImagePreview from "filepond-plugin-image-preview"; // @see https://pqina.nl/filepond/docs/api/plugins/image-preview/
//import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size'; // @see https://pqina.nl/filepond/docs/api/plugins/file-validate-size/
//import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'; // @see https://pqina.nl/filepond/docs/api/plugins/file-validate-type/

// Helper Functions
import * as helpers from "./utils/helpers";

// Pages Scripts
import * as pages from "./pages"; 

// Global Store
import store from "./store";

// Breakpoints Store
import breakpoints from "./utils/breakpoints";

// Alpine Components
import usePopper from "./components/usePopper";
import accordionItem from "./components/accordionItem";
import navLink from "./components/navLink";
import tasks from "./components/tasks";

// Alpine Directives
import tooltip from "./directives/tooltip";
import inputMask from "./directives/inputMask";

// Marumbi
import { PermissionVisualizer } from "./marumbi/permission-visualizer"
import { MonacoDslPlugin } from "./marumbi/monaco-dsl"

// Jquery for the markdown editor
import { jQuery, $ } from "https://code.jquery.com/jquery-4.0.0.module.min.js";

window.jQuery = jQuery;
window.$ = $;

// Register HTML, XML language for highlight.js
// Just for demo purpose only for highlighting code
hljs.registerLanguage("xml", xml);
hljs.registerLanguage("json", json);
hljs.registerLanguage("ini", ini);
hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("yaml", yaml);
hljs.registerLanguage("typescript", typescript);
hljs.configure({ ignoreUnescapedHTML: true });

// Register filepond plugins
//FilePond.registerPlugin(FilePondPluginImagePreview);
//FilePond.registerPlugin(FilePondPluginFileValidateSize);
//FilePond.registerPlugin(FilePondPluginFileValidateType);
 
window.Drawer = Drawer;
window.hljs = hljs;
window.Swiper = Swiper;
window.Sortable = Sortable;
/*window.FilePond = FilePond;*/

window.Alpine = Alpine;
window.helpers = helpers;
window.pages = pages;
window.marumbi = {
    visualizer: PermissionVisualizer,
    monaco: MonacoDslPlugin
};

Alpine.plugin(persist);
Alpine.plugin(collapse);
Alpine.plugin(intersect);

Alpine.directive("tooltip", tooltip);
Alpine.directive("input-mask", inputMask);

Alpine.magic("notification", () => notification);

Alpine.store("breakpoints", breakpoints);
Alpine.store("global", store);

Alpine.data("usePopper", usePopper);
Alpine.data("accordionItem", accordionItem);
Alpine.data("navLink", navLink);
Alpine.data("tasks", tasks);

window.highlightJson = (json) => {
    return window.hljs.highlight(JSON.stringify(json), { language: 'json' }).value;
};

window.highlightJsonFromText = (json) => {
    return window.hljs.highlight(json, { language: 'json' }).value;
};

window.downloadTextFile = (fileName, contentType, content) => {
    const blob = new Blob([content], { type: contentType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.setTimeout(() => URL.revokeObjectURL(url), 0);
};
